// TODO: make this edm as a separate package in smart project?
import _ from 'underscore';
import { EDM } from '@bingads-webui/edm-core';
import { resIdsPlugin } from '@bingads-webui/edm-resource-identifiers';
import { odataPlugin } from '@bingads-webui/edm-odata';
import { odataBulkUpsertPlugin } from '@bingads-webui/edm-bulk';
import { defineConstProperty } from '@bingads-webui/reflection';
import { schemas } from '@bingads-webui/campaign-odata-schemas';
import * as bulkUpsertSchema from '@bingads-webui/odata-bulk-upsert-config';

export const edm = new EDM({
  schemas: {
    $ROOT: {
      $$ref: '$ROOT',
      type: 'object',
      properties: {
        Customers: {
          type: 'array',
          items: schemas['Model/Customer'],
        },
      },
      $$ODataExtension: {
        Name: '$ROOT',
        NavigationProperty: [
          'Customers',
        ],
      },
    },
    ..._.mapObject(
      schemas,
      (schema, name) => _.extend(schema, { $$ref: name })
    ),
  },
});

resIdsPlugin(edm);

odataPlugin(edm, '' /* we don't use edm to send request so make host url empty */, {});

odataBulkUpsertPlugin(edm, _.extend({}, window.campaignODataConfigs, {
  bulkUpsertSchema,
}));

const root = edm.types.resolve('$ROOT');

const rootResourceIdentifier = new root.ResourceIdentifier();
defineConstProperty(edm, 'root', rootResourceIdentifier);
defineConstProperty(edm, 'Customers', rootResourceIdentifier.Customers);
